import React, { useContext } from 'react';
import { Context } from '../../views/app'

const AddActivity = (props) => {

    const appContext = useContext(Context);
    let user = appContext.user;
    let onActivityApplyClick = props.onActivitySelected;
    let activityTempates = props.activityTemplates;
    let customTemplate = props.customTemplate;

    let onApplyActivity = (activity) => {
        let activityToApply = { ...activity };
        activityToApply.activity_id = activityToApply.activity_id + 'SITESUPT';
        activityToApply.site_id = user.site_selected.site_id;
        activityToApply.customer_id = user.customer_id;
        activityToApply.activity_name = activityToApply.activity_name + " " + new Date().toLocaleTimeString('it-IT');
        onActivityApplyClick(activityToApply);
        props.closeModal();
        if (activity.activity_id === 6) {
            props.checkAllZones();
        }
    }
    return (
        <React.Fragment>
            <div className="modal-header p-2 bg-primary text-white">
                <span className="modal-title">{props.title}</span>
                <div>
                    <button type='button' className='fa fa-expand' onClick={props.resizeModal}></button>
                    <button type='button' className='far fa-lg fa-times-circle pull-right' data-dismiss='modal' onClick={props.closeModal}></button>
                </div>
            </div>
            <div className="modal-body">
                <div>
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th colSpan="2">Template Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {activityTempates && activityTempates.map((activity, k) => (
                                <tr key={k}>
                                    <td className="p-2" valign="center" >{activity.activity_name}</td>
                                    <td className="p-2" width="50px"><button className="btn btn-sm btn-primary" onClick={(e) => onApplyActivity(activity)}>Apply</button></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            {
                customTemplate &&
                <div className="modal-footer bg-light p-1">
                    <button className="btn btn-sm btn-success" onClick={(e) => onApplyActivity({ ...customTemplate })}>Create Custom Settings</button>
                </div>
            }

        </React.Fragment>
    );
}

export default AddActivity;